import newTypes from './proDisplay.newtypes';
import oldTypes from './proDisplay.oldtypes';

export default {...newTypes, ...oldTypes};